import React from "react";
import styles from "../components/auctionLots/BidModule.module.scss";
import { getLiveAuctionUrl } from "./liveAuctionSchedule";
/**
 * Replaces the "Gi bud" button once the auction is run on the live site.
 * It is a plain link: the server signs the member in (or asks to log in first) and redirects to live.skanfil.no.
 */
export default function LiveAuctionButton({ lotId, label, price, style }) {
    return (React.createElement("a", { className: styles.bidButton, href: getLiveAuctionUrl(lotId, price), style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            textDecoration: "none",
            ...style,
        } }, label));
}
